/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import AlertService from '../../services/alerts.service';
import CommentsService from '../../services/comments.service';
import 'react-tabs/style/react-tabs.css';
import memoize from 'memoize-one';
import moment from 'moment';
import { PageView, Event } from "../GoogleAnalytics";

//import { jsAsset, alertCustomer, jsAlert, jsGraph, jsOpportunity, jsUpdateOpportunity, jsGraphData } from "../../componentObjects";

import TriageAlertsTable from '../TriageAlerts/TriageAlertsTable';
import alerttypemessagingService from "../../services/alerttypemessaging.service";
import { consolidateAlerts } from "../../utils/alertUtils";

class AlertQuestions extends Component {
    static displayName = AlertQuestions.name;
    _isMounted = false;

    constructor(props) {
        super(props);

        this.getAlerts = this.getAlerts.bind(this);
        this.getUpdatedAlerts = this.getUpdatedAlerts.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
        this.reloadTable = this.reloadTable.bind(this);
        this.filterAlerts = this.filterAlerts.bind(this);
        this.consolidateAlerts = this.consolidateAlerts.bind(this);
        this.addConversationToAlert = this.addConversationToAlert.bind(this);
        this.updateAlertList = this.updateAlertList.bind(this);

        this.state = {
            alertArgs: {
                queryId: "custom",
                startTime: null,
                endTime: null,
                isActive: true,
                priority: 3
            },
            alertType: "Active",
            alertList: [],
            loading: true,
            alertTableLoading: false,
            alertMessaging: [],
            assetComments: [],
            partnerInfo: {},
            tableObj: {},
            startTabIndex: 0,
            consolidateAlertsDict: {}
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        PageView();
        this.getAlerts();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentCustomerId !== this.props.currentCustomerId) {
           this.getAlerts();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    memAlerts = memoize(this.getAlerts);

    async getAlerts(id, start = null, end = null) {
        var startTime = performance.now();
        var now = (end == null ? moment() : end);
        var before = (start == null ? moment(now).add(-2, 'years') : start);//moment(now).add(-2, 'weeks'); //two weeks ago; set only for demo set 04/01/21
        var nowStr = now.format();
        var beforeStr = before.format();
        var startTabIndex = 0;
        var alertList = [];

        var alertArgs = {
            alertTagIds: [], //[TagIdsEnum.QuestionAsked],
            alertTypeIds: null,
            startTime: beforeStr,
            endTime: nowStr,
            isClosed: false,
            isActive: true,
            isMuted: false,
            parentAssetId: null
        }

        this.setState(prevState => ({
            alertTableLoading: true,
            alertArgs: {
                ...prevState.alertArgs,
                startTime: beforeStr,
                endTime: nowStr
            }
        }), async () => {
            await CommentsService.getassetcomments()
                .then(response3 => {
                    if (this._isMounted) {
                        let assetComments = response3.data;
                        if (assetComments !== null && assetComments !== undefined && assetComments.length) {
                            assetComments = assetComments.filter(c => c.hasQuestion);
                        }
                        this.setState({ assetComments: assetComments }, () => {
                            if (assetComments !== null && assetComments !== undefined && assetComments.length) {

                                    alerttypemessagingService.getpartnermessaging(this.props.currentPartnerId)
                                        .then(response2 => {
                                            if (this._isMounted) {
                                                this.setState({ alertMessaging: response2 }, async () => {
                                                    if (this._isMounted) {
                                                        let questionArgs = {
                                                            assetComments: assetComments,
                                                            args: this.state.alertArgs
                                                        }; 
                                                        await AlertService.getquestionalertlist(questionArgs) 
                                                            .then(response => {
                                                                if (this._isMounted) {
                                                                    var tempData = [];
                                                                    for (let x in response.data) {
                                                                        if (response.data.hasOwnProperty(x)) {
                                                                            var alert = response.data[x];
                                                                            var tempObject = {
                                                                                alertId: alert.alertId,
                                                                                typeId: alert.typeId,
                                                                                typeName: alert.type,
                                                                                alertMessage: alert.message,
                                                                                severity: "Critical",
                                                                                alert: alert
                                                                            }
                                                                            tempData.push(tempObject);
                                                                        }
                                                                    };
                                                                    var tempTableObj = {
                                                                        alerts: response.data,
                                                                        equipmentAlertsList: tempData,
                                                                        equipmentCount: tempData.length
                                                                    };

                                                                    this.setState({ tableObj: tempTableObj, loading: false, alertTableLoading: false, startTabIndex: 0 }, async () => {
                                                                        this.consolidateAlerts(tempData);
                                                                    });
                                                                }
                                                            })
                                                            .catch(e => {
                                                                console.log(e);
                                                                this.setState({ alertTableLoading: false, loading: false });
                                                            });
                                                    }

                                                });
                                            }
                                                
                                        });
                            }
                            else {
                                this.setState({ alertTableLoading: false, loading: false });
                            }
                        });
                    }

                })
                .catch(e => {
                    console.log(e);
                    this.setState({ alertTableLoading: false, loading: false });
                })
        });
    }

    getUpdatedAlerts(comments) {
        this.setState({ loading: true, alertTableLoading: true, assetComments: comments }, async () => {
            if (this._isMounted) {
                let questionArgs = {
                    assetComments: comments,
                    args: this.state.alertArgs
                }; 
                await AlertService.getquestionalertlist(questionArgs) 
                    .then(response => {
                        if (this._isMounted) {
                            var tempData = [];
                            for (let x in response.data) {
                                if (response.data.hasOwnProperty(x)) {
                                    var alert = response.data[x];
                                    var tempObject = {
                                        alertId: alert.alertId,
                                        typeId: alert.typeId,
                                        typeName: alert.type,
                                        alertMessage: alert.message,
                                        severity: "Critical",
                                        alert: alert
                                    }
                                    tempData.push(tempObject);
                                }
                            };
                            var tempTableObj = {
                                alerts: response.data,
                                equipmentAlertsList: tempData,
                                equipmentCount: tempData.length
                            };

                            this.setState({ tableObj: tempTableObj, loading: false, alertTableLoading: false, startTabIndex: 0 }, async () => {
                                this.consolidateAlerts(tempData);
                            });
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        this.setState({ alertTableLoading: false, loading: false });
                    });
            }
        })
    }

    consolidateAlerts(alerts) {
        const isDeviceHealthAlerts = this.state.startTabIndex === 1;
        const { distinctAlerts, consolidatedAlertsDict } = consolidateAlerts(alerts, isDeviceHealthAlerts);

        if (this._isMounted) {
            this.setState({ alertList: distinctAlerts, consolidateAlertsDict: consolidatedAlertsDict, loading: false, alertTableLoading: false });
        }
    }

    async filterAlerts(tabIndex, radio, isActive, isScheduled, selectedTypes) {
        if (this.state.tableObj.equipmentAlertsList !== null && this.state.tableObj.equipmentAlertsList !== undefined)
            this.setState({ alertTableLoading: true }, () => {
                let alerts = tabIndex == 0 ? this.state.tableObj.equipmentAlertsList : this.state.tableObj.deviceAlertsList;

                if (radio === "Critical")
                    alerts = alerts.filter(a => a.severity === "Critical");
                else if (radio === "Warning")
                    alerts = alerts.filter(a => a.severity === "Warning");

                if (isActive !== null) {
                    if (isActive == true)
                        alerts = alerts.filter(a => a.alert.isActive == true);
                    else
                        alerts = alerts.filter(a => a.alert.isActive == false);
                }

                if (isScheduled !== null) {
                    if (isScheduled == true)
                        alerts = alerts.filter(a => a.alert.isMuted == true);
                    else
                        alerts = alerts.filter(a => a.alert.isMuted == false);
                }

                this.consolidateAlerts(alerts); //this.setState({ alertList: alerts, alertTableLoading: false });  
            });
    }

    reloadTable() {
        this.setState({
            alertTableLoading: true,
            alertList: []
        });

        this.setState(prevState => ({
            alertArgs: {
                ...prevState.alertArgs,
                isActive: this.state.alertType === "Inactive" ? false : true
            },
            alertTableLoading: true,
            alertList: []
        }), async () => {
            await this.getAlerts();
        });
    }

    async changeRadio(val) {
        let x = val;
        Event("Alert Questions Radio Clicked", "User clicked one of the radio buttons for the alert table in Alert Questions", "Alert Questions Radio Clicked");

        this.setState({
            alertType: x,
            alertList: []
        });

        this.setState(prevState => ({
            alertArgs: {
                ...prevState.alertArgs,
                isActive: x === "Inactive" ? false : true
            }
        }));

        this.setState({ alertTableLoading: true }, async () => {
            await this.getAlerts();
        });
    }

    addConversationToAlert(conversationId, alertId) {
        var index = 0;
        var alert = null;

        index = this.state.tableObj.alerts.findIndex(a => {
            return a.alertId === alertId;
        });

        var tempTableObj = [...this.state.tableObj.alerts];
        alert = { ...tempTableObj[index] };
        alert.conversationId = conversationId.toString();
        tempTableObj[index] = alert;

        this.setState(prevState => ({
            tableObj: {
                ...prevState.tableObj,
                alerts: tempTableObj
            }
        }));
    }

    updateAlertList(alertsTable) {
        this.setState({ alertList: alertsTable });
    }

    render() {
        const { classes } = this.props;
        return (
            <div sx={(theme)=>({
                [theme.breakpoints.down('md')]: {
                    marginLeft: '-225px !important',
                },
            })}>
                <div className="infoPage">
                    <h2 className="pageTitle dashboard-title" id="tabelLabel">
                        Alert Questions
                    </h2>

                    <TriageAlertsTable alertList={this.state.alertList} startTabIndex={this.state.startTabIndex} _isMounted={this._isMounted} loading={this.state.loading} alertTableLoading={this.state.alertTableLoading}
                        alertMessaging={this.state.alertMessaging} assetComments={this.state.assetComments} tableObj={this.state.tableObj}
                        filterAlerts={this.filterAlerts} reloadTable={this.reloadTable} customers={this.props.customers} consolidateAlertsDict={this.state.consolidateAlertsDict} addConversationToAlert={this.addConversationToAlert} userOrg={this.props.userOrg} updateAlertList={this.updateAlertList}
                        setActivePath={this.props.setActivePath} source="AlertQuestions" updateSearch={this.getAlerts} getUpdatedAlerts={this.getUpdatedAlerts}/>

                </div>
            </div>
        );
    }
}

export default AlertQuestions;